__turbopack_context__.v({
  "className": "_19wr9q_className",
  "variable": "_19wr9q_variable",
});
